
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!developer_key";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'developer-key';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  return " inactive";
  }

function program3(depth0,data) {
  
  
  return "<br/><i>inactive</i>";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <a href=\"/users/";
  if (helper = helpers.user_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.user_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            ";
  return buffer;
  }

function program7(depth0,data) {
  
  
  return "\n            </a>\n            ";
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <a href=\"/accounts/";
  if (helper = helpers.account_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.account_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'redirect_uri': ((depth0 && depth0.redirect_uri)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "uri_redirect_uri_d4aad2b9", "URI: %{redirect_uri}", options) : helperMissing.call(depth0, "t", "uri_redirect_uri_d4aad2b9", "URI: %{redirect_uri}", options)))
    + "\n                ";
  return buffer;
  }

function program13(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.last_used_at) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.last_used_at); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program15(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "never_df100b49", "Never", options) : helperMissing.call(depth0, "t", "never_df100b49", "Never", options)));
  }

function program17(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <div>\n            ";
  if (helper = helpers.notes) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.notes); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        </div>\n      ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <a href=\"#\" role=\"checkbox\" aria-checked=\"false\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "activate_key_name_a99df672", "Activate key %{name}", options) : helperMissing.call(depth0, "t", "activate_key_name_a99df672", "Activate key %{name}", options)))
    + "\" class=\"activate_link\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "activate_this_key_6cd98f4b", "Activate this key", options) : helperMissing.call(depth0, "t", "activate_this_key_6cd98f4b", "Activate this key", options)))
    + "\"><i class=\"icon-unlock standalone-icon\"></i></a>\n        ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <a href=\"#\" role=\"checkbox\" aria-checked=\"true\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "activate_key_name_a99df672", "Activate key %{name}", options) : helperMissing.call(depth0, "t", "activate_key_name_a99df672", "Activate key %{name}", options)))
    + "\" class=\"deactivate_link\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "deactivate_this_key_3e79a2b5", "Deactivate this key", options) : helperMissing.call(depth0, "t", "deactivate_this_key_3e79a2b5", "Deactivate this key", options)))
    + "\"><i class=\"icon-lock standalone-icon\"></i></a>\n        ";
  return buffer;
  }

  buffer += "<tr class='key";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inactive), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "'>\n    <td class=\"name\">\n        <img class=\"icon\" alt=\"\" src=\"";
  if (helper = helpers.icon_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.icon_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inactive), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </td>\n    <td>\n        <div>\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.user_id), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  if (helper = helpers.user_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.user_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.user_id), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n        <div>";
  if (helper = helpers.email) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.email); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n        <div>\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.account_id), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  if (helper = helpers.account) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.account); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.account_id), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n    </td>\n    <td>\n        <div class=\"details\">\n            <div>\n               "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'id': ((depth0 && depth0.id)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "id_id_4e148481", "ID: %{id}", options) : helperMissing.call(depth0, "t", "id_id_4e148481", "ID: %{id}", options)))
    + "\n            </div>\n            <div>\n               "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'api_key': ((depth0 && depth0.api_key)),
    'w0': ("<span class=\"api_key\">$1</span>"),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "key_api_key_68bf80ae", "Key: *%{api_key}*", options) : helperMissing.call(depth0, "t", "key_api_key_68bf80ae", "Key: *%{api_key}*", options)))
    + "\n            </div>\n            <div>\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.redirect_uri), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </div>\n        </div>\n    </td>\n    <td>\n        <div>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'access_token_count': ((depth0 && depth0.access_token_count)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "access_token_count_access_token_count_dfb5463c", "Access Token Count: %{access_token_count}", options) : helperMissing.call(depth0, "t", "access_token_count_access_token_count_dfb5463c", "Access Token Count: %{access_token_count}", options)))
    + "\n        </div>\n        <div>\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "created_6ee36dff", "Created:", options) : helperMissing.call(depth0, "t", "created_6ee36dff", "Created:", options)))
    + " "
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.created_at), options)))
    + "\n        </div>\n        <div>\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "last_used_f9457313", "Last Used:", options) : helperMissing.call(depth0, "t", "last_used_f9457313", "Last Used:", options)))
    + " ";
  stack1 = (helper = helpers.ifExists || (depth0 && depth0.ifExists),options={hash:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.last_used_at), options) : helperMissing.call(depth0, "ifExists", (depth0 && depth0.last_used_at), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </div>\n    </td>\n    <td class='notes'>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.notes), {hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </td>\n    <td class='links'>\n        <a href=\"#\" class=\"edit_link\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_key_name_5c7d2f46", "Edit key %{name}", options) : helperMissing.call(depth0, "t", "edit_key_name_5c7d2f46", "Edit key %{name}", options)))
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("developer_key")
  },data:data},helper ? helper.call(depth0, "edit_key", "Edit this key", options) : helperMissing.call(depth0, "t", "edit_key", "Edit this key", options)))
    + "\"><i class=\"icon-edit standalone-icon\"></i></a>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.inactive), {hash:{},inverse:self.program(21, program21, data),fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <a href=\"#\" class=\"delete_link\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "delete_this_key_70f74aa1", "Delete this key", options) : helperMissing.call(depth0, "t", "delete_this_key_70f74aa1", "Delete this key", options)))
    + "\"><i class=\"icon-trash standalone-icon\"></i></a>\n    </td>\n</tr>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  